import { Tooltip } from '@statsbomb/kitbag-components';
import { VideoStatus } from '@statsbomb/parachute-types';
import { ReactNode } from 'react';
import { usePlayButtonFeedback } from '@/hooks/usePlayButtonFeedback';

export const NoVideoLicenceTooltip = ({ children, videoStatus }: { children: ReactNode; videoStatus: VideoStatus }) => {
  const message = usePlayButtonFeedback(videoStatus);

  return (
    <Tooltip delay={200} content={<div className="max-w-64">{message}</div>}>
      {children}
    </Tooltip>
  );
};
